import PropTypes from "prop-types";

const getFeatureMatchesValue = (features, featureName, value, showUnset) => {
  if (!features || !features.length) return showUnset;

  const aFeature = features.find(
    feature => feature && feature.name === featureName
  );
  return aFeature ? aFeature.value === value : showUnset;
};

const FeatureRenderer = ({ children, features, feature, value, showUnset }) => {
  if (typeof children === "function") {
    const featureObj = features.find(({ name }) => name === feature) || {};
    return children(featureObj.value);
  }
  return getFeatureMatchesValue(features, feature, value, showUnset)
    ? children
    : null;
};

FeatureRenderer.propTypes = {
  features: PropTypes.array.isRequired,
  feature: PropTypes.string.isRequired,
  value: PropTypes.any,
  showUnset: PropTypes.bool
};

FeatureRenderer.defaultProps = {
  value: true,
  showUnset: false
};

export default FeatureRenderer;
